import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";

interface DailyLimitProps {
  preferences?: {
    maxNotificationsPerDay?: number | null;
  } | null;
  onUpdate: (updates: Record<string, number>) => void;
}

export function DailyLimit({ preferences, onUpdate }: DailyLimitProps) {
  return (
    <Card className="card-elevated border-none shadow-premium">
      <CardHeader>
        <CardTitle>Daily Limit</CardTitle>
        <CardDescription>
          Maximum number of notifications you'll receive per day
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <Label htmlFor="max-notifications">Maximum notifications per day</Label>
            <span className="text-lg font-semibold tabular-nums">
              {preferences?.maxNotificationsPerDay ?? 4}
            </span>
          </div>
          <Slider
            id="max-notifications"
            min={1}
            max={10}
            step={1}
            value={[preferences?.maxNotificationsPerDay ?? 4]}
            onValueChange={([value]) => onUpdate({ maxNotificationsPerDay: value })}
            className="w-full"
          />
          <p className="text-sm text-muted-foreground">
            After reaching this limit, you won't receive more notifications until the next day.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
